export default {
    menu: {
        dashboard: "لوحة التحكم",
        store: "المتجر",
        profile: "الملف الشخصى",
        setting: "الاعدادات",
        general: "عام",
        news: "الاخبار",
        app: "التطبيق",
        tasks: "المهام",
        contact: "تواصل معنا",
        info: "عنا",
        website: "الموقع الالكترونى",
        home: "الرئيسية",
        system: "النظام",
        about: "عنا",
        "logout": "تسجيل خروج",
        "fileExplorer": "متصفح الملفات",
        "shortcut": "الاختصارات",
        "persons": "الاشخاص",
        "users": "المستخدمين",
        "roles": "الادوار",
        "list": "القائمة",
        "add": "اضافة",
        "session": "الاجهزة المفتوحة",
        "license": "الترخيص"
    },
    eid: {
        fitrTitle: "عيد فطر مبارك",
        fitrSubtitle: "كل عام وأنتم بخير",
        fitrMessage: "تقبل الله منا ومنكم صالح الأعمال",
        adhaTitle: "عيد أضحى مبارك",
        adhaSubtitle: "كل عام وأنتم بخير",
        adhaMessage: "تقبل الله منا ومنكم صالح الأعمال والأضاحي"
    },
    signIn: {
        welcome: "مرحبا بك يا",
        signIn: "سجل الدخول للاستمرار",
        button: "تسجيل الدخول",
        description: "وصول آمن إلى مساحة العمل والإضافات وبيانات أعمالك من مكان واحد.",
        features: {
            protected: "دخول محمي",
            fast: "وصول سريع إلى مساحة العمل",
            unified: "لوحة تحكم موحدة"
        }
    },
    text: {
        "addNewUser": "اضافة مستخدم جديد",
        "editedUser": "تعديل مستخدم",
        "addNewRole": "اضافة دور جديد",
        "EditedRole": "تعديل دور",
        "roleInfo": "بيانات الدور",
        edited: "تعديل",
        done: "تم الحفظ",
        sureLogout: "هل تريد تسجيل خروج ",
        error: "حدث خظا",
        areSure: "هل انت متاكد من حذف العنصر ",
        confirmation: "تأكيد!",
        yes: "نعم",
        no: "لا",
        loading: "جاري التحميل",
        view: "عرض"
    },
    form: {
        email: "الايميل",
        name: "الاسم",
        username: "اسم المستخدم",
        password: "الرقم السري",
        state: "الحالة",
        "id": "الرقم التعريفى",
        "role": "الدور",
        image: "الصورة",
        description: "الوصف",
        address: "العنوان",
        type: "النوع",
        version: "الاصدار",
        phone: "رقم الجوال",
        subject: "الموضوع",
        department: "القسم",
        path: "الرابط",
        message: "الرسالة",
        search: "البحث",
        actions: "الإجراءات",
        status: "الحالة",
        app: "التطبيق"
    },
    placeholder: {
        search: "البحث في الملفات والمجلدات..."
    },
    button: {
        add: "اضافة",
        delete: "حذف",
        save: "حفظ",
        close: "اغلاق",
        open: "فتح",
        refresh: "تراجع",
        "upload": "تحميل",
        check: "تحقيق",
        validateToken: "التحقق من صحة الرخصة",
        license: "رخصة البرنامج",
        differentLicense: "رخضة جديدة",
        more: "تصفح",
        "create": "انشاء",
        "edited": "تعديل",
        "view": "رؤية",
        update: "تحديث",
        send: "ارسال",
        done: "تم",
        edit: "تعديل"
    },
    setting: {
        scale: "الحجم",
        menu: "نوع القائمة",
        language: "اللغة",
        theme: "المظهر",
        subtitle: "خصص تجربتك",
        display: "العرض",
        allThemes: "الكل",
        lightThemes: "فاتح",
        darkThemes: "داكن"
    },
    store: {
        subtitle: "تصفح وإدارة الإضافات والتطبيقات",
        features: "المميزات",
        version: "الاصدرات السابقة",
        faq: "الاسئلة الشائعة",
        // View Options & Categories
        view_grid: "عرض شبكي",
        view_table: "عرض جدول",
        all_categories: "جميع التصنيفات",
        categories: "التصنيفات",
        pricing: "الأسعار",
        // Plugin Management
        plugin: "إضافة",
        plugins: "الإضافات",
        application: "تطبيق",
        applications: "التطبيقات",
        all_types: "جميع الأنواع",
        no_products: "لم يتم العثور على إضافات",
        try_different_search: "جرب تعديل البحث أو معايير التصفية",
        // Installation Status
        free: "مجاني",
        requiresLicense: "يتطلب ترخيص",
        proOnly: "مدفوع / يتطلب ترخيص",
        activateLicense: "تفعيل الترخيص",
        licenseRequired: "يتطلب مفتاح ترخيص",
        installed: "مثبت",
        not_installed: "غير مثبت",
        can_install: "يمكن التثبيت",
        restricted: "محظور",
        installation_denied: "التثبيت مرفوض",
        installation_restricted: "غير مسموح لك بتثبيت هذه الإضافة",
        // Plugin States
        running: "يعمل",
        stopped: "متوقف",
        plugin_running: "الإضافة تعمل",
        plugin_stopped: "الإضافة متوقفة",
        // Actions
        install_plugin: "تثبيت الإضافة",
        update_plugin: "تحديث الإضافة",
        enable_plugin: "تفعيل الإضافة",
        disable_plugin: "إيقاف الإضافة",
        uninstall_plugin: "إلغاء تثبيت الإضافة",
        open_plugin: "فتح الإضافة",
        // Status Messages
        installing: "جاري تثبيت الإضافة",
        installing_message: "جاري تثبيت {name}...",
        installed_success: "تم تثبيت الإضافة",
        installed_message: "تم تثبيت {name} بنجاح",
        updating: "جاري تحديث الإضافة",
        updating_message: "جاري تحديث {name} إلى الإصدار {version}...",
        updated_success: "تم تحديث الإضافة",
        updated_message: "تم تحديث {name} بنجاح",
        enabling: "جاري تفعيل الإضافة",
        enabled_success: "تم تفعيل الإضافة",
        enabled_message: "تم تفعيل {name}",
        disabling: "جاري إيقاف الإضافة",
        disabled_success: "تم إيقاف الإضافة",
        disabled_message: "تم إيقاف {name}",
        uninstalling: "جاري إلغاء تثبيت الإضافة",
        uninstalled_success: "تم إلغاء تثبيت الإضافة",
        uninstalled_message: "تم إلغاء تثبيت {name}",
        // Error Messages
        installation_failed: "فشل في التثبيت",
        update_failed: "فشل في التحديث",
        enable_failed: "فشل في التفعيل",
        disable_failed: "فشل في الإيقاف",
        uninstall_failed: "فشل في إلغاء التثبيت",
        failed_install: "فشل في تثبيت الإضافة",
        failed_update: "فشل في تحديث الإضافة",
        failed_enable: "فشل في تفعيل الإضافة",
        failed_disable: "فشل في إيقاف الإضافة",
        failed_uninstall: "فشل في إلغاء تثبيت الإضافة",
        // Confirmation
        confirm_uninstall: "تأكيد إلغاء التثبيت",
        confirm_uninstall_message: "هل أنت متأكد من أنك تريد إلغاء تثبيت {name}؟ لا يمكن التراجع عن هذا الإجراء.",
        // Filters and Search
        installation_status: "حالة التثبيت",
        plugin_state: "حالة الإضافة",
        all_plugins: "جميع الإضافات",
        all_states: "جميع الحالات",
        updates_only: "التحديثات فقط",
        show_all: "عرض الكل",
        // Version and Status
        latest_version: "أحدث إصدار",
        installed_version: "الإصدار المثبت",
        update_available: "تحديث متاح",
        up_to_date: "محدث",
        allowed_to_install: "مسموح بالتثبيت",
        plugin_installed: "الإضافة مثبتة",
        // Details Page
        installation: "التثبيت",
        runtime: "وقت التشغيل",
        updates: "التحديثات",
        rating: "التقييم",
        price: "السعر",
        free: "مجاني",
        learn_more: "معرفة المزيد",
        details: "التفاصيل"
    },
    404: {
        lost: "يبدو أنك فقدت",
        available: "المورد المطلوب غير متوفر."
    },
    "fileExplorer": {
        "folders": "المجلدات",
        "files": "الملفات",
        "rename": "اعادة تسمية",
        "download": "تحميل",
        "shortcut": "اختصار",
        "emptyFolder": "هذا المجلد فارغ",
        "emptyFolderDescription": "لم يتم العثور على ملفات أو مجلدات في هذا الموقع. يمكنك رفع الملفات أو إنشاء مجلدات جديدة للبدء.",
        "noPreview": "لا يمكن المعاينة",
        "noPreviewDescription": "لا يمكن معاينة هذا النوع من الملفات. يمكنك تحميل الملف لعرضه.",
        "previewError": "فشل في المعاينة",
        "previewErrorDescription": "حدث خطأ أثناء محاولة معاينة هذا الملف. لا يزال بإمكانك تحميله.",
        "openWith": "فتح باستخدام"
    },
    dashboard: {
        emptyState: {
            title: "لا توجد عناصر متاحة",
            description: "لوحة التحكم فارغة. قم بتثبيت الإضافات لإضافة عناصر وتخصيص تجربتك."
        },
        subtitle: "نظرة عامة على مساحة عملك",
        addWidget: "إضافة عنصر",
        editLayout: "تعديل التخطيط",
        allWidgetsAdded: "جميع العناصر المتاحة موجودة بالفعل في لوحة التحكم!",
        widgetDescription: "عنصر من إضافة مخصصة"
    },
    tasks: {
        emptyState: {
            title: "لا توجد مهام متاحة",
            description: "لم يتم العثور على مهام للتشغيل. قم بتثبيت الإضافات التي تحتوي على وظائف المهام لرؤية المهام المتاحة."
        }
    },
    contact: {
        title: "تواصل معنا",
        subtitle: "نحن نحب أن نسمع منك. أرسل لنا رسالة وسنرد في أقرب وقت ممكن.",
        form: {
            title: "أرسل لنا رسالة",
            send: "إرسال الرسالة",
            selectDepartment: "اختر القسم (اختياري)",
            requiredFields: "يرجى ملء جميع الحقول المطلوبة.",
            rateLimited: "تم تجاوز الحد المسموح للطلبات. يرجى الانتظار 30 دقيقة قبل إرسال رسالة أخرى."
        },
        departments: {
            support: "الدعم الفني",
            sales: "المبيعات والفوترة",
            licensing: "الترخيص والتفعيل",
            feedback: "الاقتراحات والملاحظات",
            general: "استفسارات عامة"
        },
        social: {
            title: "تواصل معنا",
            subtitle: "تواصل معنا عبر المنصة المفضلة لديك",
            email: "راسلنا",
            phone: "اتصل بنا",
            telegram: "بوت تليجرام",
            whatsapp: "واتساب",
            facebook: "فيسبوك",
            website: "الموقع الإلكتروني",
            linkedin: "لينكد إن",
            instagram: "إنستغرام"
        }
    },
    news: {
        title: "الأخبار والتحديثات",
        subtitle: "ابق على اطلاع بآخر التحديثات",
        loading: "جاري تحميل الأخبار...",
        noNews: "لا توجد أخبار متاحة",
        noNewsMessage: "تحقق مرة أخرى لاحقاً للحصول على التحديثات",
        readMore: "اقرأ المزيد",
        share: "مشاركة",
        copied: "تم النسخ",
        linkCopied: "تم نسخ الرابط إلى الحافظة",
        loadMore: "تحميل المزيد"
    },
    license: {
        title: "إدارة الترخيص",
        subtitle: "إدارة معلومات ترخيص Motanamy EA الخاص بك",
        currentLicense: "الترخيص الحالي",
        status: "الحالة",
        type: "النوع",
        issuedTo: "صادر لـ",
        validateToken: "التحقق من الرمز",
        refreshLicense: "تحديث الترخيص",
        validation: "التحقق من الترخيص",
        refresh: "تحديث الترخيص",
        refreshed: "تم تحديث معلومات الترخيص",
        downloaded: "تم تحميل وثيقة الترخيص بنجاح",
        validToken: "الرمز صحيح وتم تطبيقه بنجاح",
        invalidToken: "رمز غير صحيح. يرجى التحقق من مفتاح الترخيص",
        validationError: "حدث خطأ أثناء التحقق. يرجى المحاولة مرة أخرى",
        status: {
            active: "نشط",
            inactive: "غير نشط",
            unauthorized: "غير مصرح",
            expired: "منتهي الصلاحية",
            pending: "قيد الانتظار",
            free: "النسخة المجانية للمجتمع"
        },
        statusDesc: {
            active: "ترخيصك نشط ويعمل بشكل كامل.",
            inactive: "ترخيصك غير نشط ويحتاج إلى اهتمام.",
            unauthorized: "ترخيصك غير مصرح حالياً ويحتاج إلى تحقق.",
            expired: "انتهى ترخيصك. يرجى التجديد للمتابعة.",
            pending: "تم تسجيل ترخيصك لكنه لم يبدأ بعد.",
            free: "أنت تعمل في وضع النسخة المجانية. يمكنك استخدام الإضافات المجانية وتفعيل مفتاح ترخيص للترقية."
        },
        activateKey: "تفعيل مفتاح الترخيص",
        enterSerialPrompt: "أدخل مفتاح الترخيص التسلسلي لتفعيل الإضافات المدفوعة والميزات المتقدمة:",
        activate: "تفعيل المفتاح",
        activating: "جاري التفعيل...",
        serialActivated: "تم تفعيل مفتاح الترخيص بنجاح!",
        invalidSerial: "مفتاح ترخيص غير صحيح. يرجى التحقق والمحاولة مرة أخرى.",
        freeNotice: "النسخة المجانية مفعلة",
        freeNoticeDesc: "أنت تستخدم نظام متنامي في وضع المجتمع المجاني مع إمكانية استخدام كافة الإضافات المجانية.",
        validationTitle: {
            success: "تم التحقق من الترخيص بنجاح",
            fail: "فشل التحقق من الترخيص",
            error: "خطأ في التحقق"
        },
        help: {
            title: "مساعدة",
            description: "إدارة ترخيص Motanamy EA وعرض الحالة الحالية. اتصل بالدعم إذا كنت بحاجة إلى مساعدة في الترخيص.",
            contactTitle: "اتصل بالدعم",
            quickActions: "إجراءات سريعة",
            downloadLicense: "تحميل الترخيص",
            viewTerms: "عرض الشروط والأحكام"
        },
        subscriptionBanner: {
            kicker: "الاشتراك",
            title: "إدارة اشتراكك من لوحة التحكم السحابية",
            description: "افتح لوحة اشتراك Motanamy لمراجعة الباقة وبيانات الفوترة وخيارات التجديد.",
            action: "فتح لوحة الاشتراك"
        },
        exportLicense: "تصدير معلومات الترخيص",
        lastVerified: "آخر تحقق",
        serial: "مفتاح الترخيص",
        copy: "نسخ",
        copied: "تم النسخ!",
        plan: "الخطة",
        devices: "الأجهزة",
        users: "المستخدمين",
        roles: "الأدوار",
        daysLeft: "يتبقى {n} يوم",
        lifetime: "ترخيص مدى الحياة",
        features: "مميزات الخطة",
        includedPlugins: "الإضافات المضمنة",
        updateAvailable: "تحديث متاح",
        loading: "جاري تحميل بيانات الترخيص…",
        errorLoad: "تعذّر تحميل بيانات الترخيص",
        noPlugins: "لا توجد إضافات مضمنة في هذا الترخيص",
        usedDevices: "تم استخدام {used} من أصل {max} جهاز",
        payType: {
            year: "سنوي",
            month: "شهري",
            own: "دائم"
        }
    },
    common: {
        close: "إغلاق"
    },
    notFound: {
        welcome: "مرحبا بك في متنامي",
        description: "منصة واحدة، إمكانيات لا حصر لها.\nقم بدمج جميع تطبيقاتك في مكان واحد من خلال مجموعة من الإضافات التي تناسب احتياجاتك.",
        dashboard: "اذهب للوحة التحكم",
        title: "الصفحة غير موجودة",
        message: "عفوا! يبدو أنك قد ضللت الطريق. <br> الصفحة التي تحاول الوصول إليها قد تكون معطلة أو محذوفة.",
        home: "العودة للرئيسية",
        back: "رجوع"
    }
}